import React, { useRef } from "react";
import { v4 as uuidv4 } from "uuid";
import Misc from "../common/Misc.svg";

import { PresetListContainer, PresetListToggle } from "../../styles";

import { Scrollbar } from "react-scrollbars-custom";
const PresetMessages = ({ presetMsg, setPresetMsg, handleSingleMessage }) => {
  const PresetList = useRef();
  const PresetToggle = useRef();
  
  const handleSelectPreset = (msg) => {
    setPresetMsg(msg);
    handleSingleMessage(msg);
    PresetList.current.classList.remove("active");
    PresetToggle.current.classList.remove("active");
  };

  const handleListOpen = () => {
    PresetToggle.current.classList.toggle("active");
    PresetList.current.classList.toggle("active");
  };

  return (
    <div className="my-3 position-relative">
      <PresetListToggle onClick={() => handleListOpen()} ref={PresetToggle}>
        {presetMsg ? presetMsg : "Pick a message"}
        {Misc.MobileSelectionTrayArrow}
      </PresetListToggle>
      <PresetListContainer ref={PresetList}>
        <Scrollbar
          style={{ width: "100%", height: presetMsgs.length * 45 }}
          noScrollX={true}
        >
          <ul>
            {presetMsgs.map((msg) => (
              <li key={uuidv4()} onClick={() => handleSelectPreset(msg)}>
                {msg}
              </li>
            ))}
          </ul>
        </Scrollbar>
      </PresetListContainer>
    </div>
  );
};

export default PresetMessages;
